import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../../assets/images/logo-win.svg";
import '../../assets/css/home.css';
import { logout } from '../../Services/loginClient';
import ComplianceConcernsModal from './CompilanceConcernsModal';

const MenuBar = ({ onNavigateAttempt }) => {
    const navigate = useNavigate();

    const handleLogout = async () => {
        const result = await logout();
        if (result.success) {
            localStorage.removeItem('user');
            navigate('/');
        } else {
            console.error('Logout failed:', result.message);
        }
    };

    const user = JSON.parse(localStorage.getItem('user'));
    const isAdmin = user?.isAdmin ;
    const [fullName, setFullname] = useState('');
    const [pharmName, setPharmName] = useState('');
    const [pharmacyId, setpharmacyId] = useState('');
    const [showComplianceModal, setShowComplianceModal] = useState(false);
    // console.log("isAdmin", isAdmin);
    
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
        setFullname(user.fullName || user.FullName);
        setPharmName(user.pharmName || user.PharmName); // corrected
        setpharmacyId(user.pharmacyId); // corrected
    }
    }, []);

    return (
    <>
        <header className="menu-bar-header">
            <nav className="menu-bar">
                {/* Left: Logo */}
                <div className="element">
                <div className="element-child" style={{display: "flex"}}>
                <div className="menu-bar-left">
                    <img src={logo} alt="Logo" className="logo" style={{ cursor: 'pointer' }}
                        onClick={() => navigate('/home')} />
                </div>

                <div className="menu-bar-center"></div>
                
                <div className="menu-bar-right" style={{ marginLeft: "20px"}}>
                <a
                    href="#/home"
                    className="menu-link"
                    onClick={e => {
                        if (onNavigateAttempt) {
                        e.preventDefault();
                        onNavigateAttempt("/home");
                        }else {
                            navigate('/home');
                        }
                        // else, allow default navigation
                    }}
                    >Home</a>

                    <div className="dropdown">
                        <span className="menu-link dropdown-button">New Orders</span>
                        <div className="dropdown-content">
                            <a
                    href='#/process-prescription'
                    className="menu-link"
                    onClick={e => {
                        if (onNavigateAttempt) {
                        e.preventDefault();
                        onNavigateAttempt('/process-prescription');
                        }else {
                            navigate('/process-prescription');
                        }
                        // else, allow default navigation
                    }}
                    style = {{ fontSize: '14px', fontFamily: 'segoe ui' }}
                    >Process Prescription</a>

                    <a
                    href='#/needs-tracking'
                    className="menu-link"
                    onClick={e => {
                        if (onNavigateAttempt) {
                        e.preventDefault();
                        onNavigateAttempt('/needs-tracking');
                        }else {
                            navigate('/needs-tracking');
                        }
                        // else, allow default navigation
                    }}
                    style = {{ fontSize: '14px', fontFamily: 'segoe ui' }}
                    >Needs Tracking</a>
                        </div>
                    </div>

                    <div className="dropdown">
                        <span className="menu-link dropdown-button">Dispensed Orders</span>
                        <div className="dropdown-content">
                            <a
                    href="#/submitted-claims"
                    className="menu-link"
                    onClick={e => {
                        if (onNavigateAttempt) {
                        e.preventDefault();
                        onNavigateAttempt("/submitted-claims");
                        }else {
                            navigate("/submitted-claims");
                        }
                        // else, allow default navigation
                    }}
                    style = {{ fontSize: '14px', fontFamily: 'segoe ui' }}
                    >Submitted Claims</a>
                     <a
                    href="#/paid-claims"
                    className="menu-link"
                    onClick={e => {
                        if (onNavigateAttempt) {
                        e.preventDefault();
                        onNavigateAttempt("/paid-claims");
                        }else {
                            navigate("/paid-claims");
                        }
                        // else, allow default navigation
                    }}
                    style = {{ fontSize: '14px', fontFamily: 'segoe ui' }}
                    >Paid Claims</a>
                     <a
                    href="#/remittance"
                    className="menu-link"
                    onClick={e => {
                        if (onNavigateAttempt) {
                        e.preventDefault();
                        onNavigateAttempt("/remittance");
                        }else {
                            navigate("/remittance");
                        }
                        // else, allow default navigation
                    }}
                    style = {{ fontSize: '14px', fontFamily: 'segoe ui' }}
                    >Remittance Reports</a>
                           
                                <a
                    href="#/cost-share-details"
                    className="menu-link"
                    onClick={e => {
                        if (onNavigateAttempt) {
                        e.preventDefault();
                        onNavigateAttempt("/cost-share-details");
                        }else {
                            navigate("/cost-share-details");
                        }
                        // else, allow default navigation
                    }}
                    style = {{ fontSize: '14px', fontFamily: 'segoe ui' }}
                    >Cost Share Details</a>
                            
                           {(pharmacyId === "PH-005-FRE")&&( <a
                    href="#/dispensed-order-cigna"
                    className="menu-link"
                    onClick={e => {
                        if (onNavigateAttempt) {
                        e.preventDefault();
                        onNavigateAttempt("/dispensed-order-cigna");
                        }else {
                            navigate("/dispensed-order-cigna");
                        }
                        // else, allow default navigation
                    }}
                    style = {{ fontSize: '14px', fontFamily: 'segoe ui' }}
                    >Dispensed Orders - Cigna</a>)}
                        </div>
                    </div>

                    <div className="dropdown">
                        <span className="menu-link dropdown-button">Cancelled Orders</span>
                        <div className="dropdown-content">
                            <a
                    href="#/entirelly-cancelled-grid"
                    className="menu-link"
                    onClick={e => {
                        if (onNavigateAttempt) {
                        e.preventDefault();
                        onNavigateAttempt("/entirelly-cancelled-grid");
                        }else {
                            navigate("/entirelly-cancelled-grid");
                        }
                        // else, allow default navigation
                    }}
                    style = {{ fontSize: '14px', fontFamily: 'segoe ui' }}
                    >Entirely Cancelled Order</a>
                     <a
                    href="#/partially-cancelled-grid"
                    className="menu-link"
                    onClick={e => {
                        if (onNavigateAttempt) {
                        e.preventDefault();
                        onNavigateAttempt("/partially-cancelled-grid");
                        }else {
                            navigate("/partially-cancelled-grid");
                        }
                        // else, allow default navigation
                    }}
                    style = {{ fontSize: '14px', fontFamily: 'segoe ui' }}
                    >Partially Cancelled Order</a>
                        </div>
                    </div>
                    <a
                    href="#/formulary-pricing"
                    className="menu-link"
                    onClick={e => {
                        if (onNavigateAttempt) {
                        e.preventDefault();
                        onNavigateAttempt("/formulary-pricing");
                        }else {
                            navigate("/formulary-pricing");
                        }
                        // else, allow default navigation
                    }}
                    
                    >Formulary & Pricing</a>

                    <a
                    href='#/upload-documents'
                    className="menu-link"
                    onClick={e => {
                        if (onNavigateAttempt) {
                        e.preventDefault();
                        onNavigateAttempt('/upload-documents');
                        }else {
                            navigate('/upload-documents');
                        }
                        // else, allow default navigation
                    }}
                    >Upload Documents</a>

                    <div className="dropdown">
                        <span className="menu-link dropdown-button">Admin</span>
                        <div className="dropdown-content">
                            {/* <a
                    href='/change-password'
                    target="_blank"
                    rel="noopener noreferrer"
                    className="menu-link"
                    onClick={e => {
                        if (onNavigateAttempt) {
                        e.preventDefault();
                        window.open('#/change-password', '_blank');
                        
                        }else {
                            navigate('/change-password');
                        }
                        // else, allow default navigation
                    }}
                    style = {{ fontSize: '14px', fontFamily: 'segoe ui' }}
                    >Change My Password</a> */}
<a
  href='#/change-password'
  target="_blank"
  rel="noopener noreferrer"
  className="menu-link"
  style={{ fontSize: '14px', fontFamily: 'segoe ui' }}
>
  Change My Password
</a>
{(isAdmin) && (
    <>
<a
  href="#/unlock-order"
  className="menu-link"
  onClick={e => {
    if (onNavigateAttempt) {
      e.preventDefault();
      onNavigateAttempt('/unlock-order');
    } else {
      e.preventDefault();
      navigate('/unlock-order');
    }
  }}
  style={{ fontSize: '14px', fontFamily: 'segoe ui' }}
>
  Unlock An Order
</a>

<a
  href="#/manage-users"
  className="menu-link"
  onClick={e => {
    if (onNavigateAttempt) {
      e.preventDefault();
      onNavigateAttempt('/manage-users');
    } else {
      e.preventDefault();
      navigate('/manage-users');
    }
  }}
  style={{ fontSize: '14px', fontFamily: 'segoe ui' }}
>
  Manage Users
</a>
    </>)}
                        </div>
                    </div>
                    <div className="dropdown">
                        <span className="menu-link dropdown-button">Contact Us</span>
                        <div className="dropdown-content">
                            <a
                        href="#/contact-us"
                        className="menu-link"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => {
                            if (onNavigateAttempt) {
                            e.preventDefault(); // prevent the default new-tab behavior
                            window.open('#/contact-us', '_blank'); // open in new tab via JS
                            onNavigateAttempt("/contact-us");
                            }
                            // No else block needed: target="_blank" handles default behavior
                        }}
                        >
                        Contact Us
                        </a>
                            <a className="menu-link"
                            onClick={() => setShowComplianceModal(true)}
                            >Compliance Concerns</a>

                        </div>

                        
                    </div>
                    {/* <a
                        href="#/contact-us"
                        className="menu-link"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => {
                            if (onNavigateAttempt) {
                            e.preventDefault(); // prevent the default new-tab behavior
                            window.open('#/contact-us', '_blank'); // open in new tab via JS
                            onNavigateAttempt("/contact-us");
                            }
                            // No else block needed: target="_blank" handles default behavior
                        }}
                        >
                        Contact Us
                        </a> */}


                    <a
                    href="#/"
                    className="menu-link"
                    onClick={e => {
                        if (onNavigateAttempt) {
                        e.preventDefault();
                        handleLogout();
                        onNavigateAttempt("/");
                        }else {
                            handleLogout();
                            navigate("/");
                        }
                        // else, allow default navigation
                    }}>Logout</a>
                </div>
                </div>
                <div className='element-child'>
                <div className="welcome-block" style={{display: "flex", justifyContent: "flex-end", marginRight: "5px"}}>
                    <span className="welcome-message">{`Welcome ${fullName}`}</span>
                </div >
                </div>
                <div className='element-child'>
                <div className="welcome-block" style={{display: "flex", justifyContent: "flex-end", marginRight: "5px"}}>
                    <span className="welcome-message">{`${pharmName}`}</span>
                </div>
                </div>
                </div>
            </nav>
        </header>
        {showComplianceModal && (
            <>
            <div
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        zIndex: 999,
        backdropFilter: 'blur(4px)',
        background: 'rgba(255,255,255,0.2)'
      }}
    />
            <ComplianceConcernsModal 
              onClose={() => setShowComplianceModal(false)}
            />
            </>
        )}
    </>
    );
};

export default MenuBar;
